import React from "react";
import SmsCodeErrorView from "./error-view";
// @ts-ignore
export default function SmsCodeError(props){
    return <SmsCodeErrorView {...props}/>
}
